// extracted by mini-css-extract-plugin
module.exports = {"content-body":"ContentBody_content-body__2OgKo","max-sm":"ContentBody_max-sm__3ynU7","max-md":"ContentBody_max-md__28H_1","max-lg":"ContentBody_max-lg__1NZWa"};